export default __webpack_public_path__ + "locales/hy-AM/CreateEditRoomDialog.json?hash=39f04da77c6605ddc5de5dd12d635729";